import { useState, useEffect, useRef } from "react";
import { fetchPublicJson } from "../lib/data-client.mjs";

export function useKortNytData(intervalMs = 60000) {
  const [items, setItems] = useState([]);
  const [breaking, setBreaking] = useState([]);
  const [loading, setLoading] = useState(true);
  const generation = useRef(null);
  useEffect(() => {
    let stopped = false;
    let timer;
    let controller;
    const poll = async () => {
      try {
        if (document.hidden && generation.current) return; // always load once, even in a background tab
        controller = new AbortController();
        const data = await fetchPublicJson("kort-nyt.json", { signal: controller.signal });
        if (!Array.isArray(data.items) || !Array.isArray(data.breaking) ||
            !Number.isFinite(Date.parse(data.generated_at))) throw new Error("Invalid Kort Nyt data");
        if (!stopped && data.generated_at !== generation.current) {
          setItems(data.items.filter((a) => a && typeof a.title === "string"));
          setBreaking(data.breaking.filter((a) => a && typeof a.title === "string"));
          generation.current = data.generated_at;
        }
      } catch { /* Keep the last successful result and retry. */ }
      finally {
        if (!stopped) { setLoading(false); timer = setTimeout(poll, intervalMs); }
      }
    };
    poll();
    return () => { stopped = true; clearTimeout(timer); controller?.abort(); };
  }, [intervalMs]);
  return { items, breaking, loading };
}
